export const SECTION_IDS = {
    ABOUT_YOU: 'AboutYou',
    EMPLOYMENT: 'Employment',
    OUTGOINGS: 'Outgoings',
    ADDRESS: 'Address'
};

export const FORM_SECTIONS = {
    [SECTION_IDS.ABOUT_YOU]: {
        InterestedInBT: 'landing-screen:balance-transfer:interested-in-bt',
        BTAmount: 'landing-screen:balance-transfer:bt-amount',
        Title: 'landing-screen:title:title',
        FirstName: 'landing-screen:full-name:first-name',
        LastName: 'landing-screen:full-name:last-name',
        DateOfBirth: 'landing-screen:date-of-birth:date-of-birth',
        DoB: 'landing-screen:date-of-birth:date-of-birth-day',
        MoB: 'landing-screen:date-of-birth:date-of-birth-month',
        YoB: 'landing-screen:date-of-birth:date-of-birth-year',
        EmailAddress: 'about-you:email-address:email-address',
        MobileNumber: 'about-you:phone-numbers:mobile-number',
        HomeNumber: 'about-you:phone-numbers:home-number'
    },
    [SECTION_IDS.EMPLOYMENT]: {
        EmploymentStatus: 'income-01:employment:employment-status',
        Occupation: 'income-01:employment:occupation',
        YearlyIncome: 'income-02:yearly-income:yearly-income',
        OtherIncome: 'income-03:other-household-income:other-household-income',
        OtherIncomeAmount: 'income-03:other-household-income:other-household-income-amount'
    },
    [SECTION_IDS.OUTGOINGS]: {
        Dependants: 'outgoings-01:dependants:number-of-dependants',
        CashAdvance: 'outgoings-02:cash-advance:cash-advance',
        ResidentialStatus: 'outgoings-03:residential-status:residential-status',
        RentOrMortgageRate: 'outgoings-03:rent-mortgage-payments:rent-mortgage-payments'
    },
    [SECTION_IDS.ADDRESS]: {
        Current: {
            LookupPostcode: 'current-address-lookup-postcode',
            ActualPostcode: 'address:current-address:postcode',
            HouseFlatNumber: 'current-address-lookup-house-number',
            HouseNumber: 'address:current-address:house-number',
            HouseName: 'address:current-address:house-name',
            FlatNumber: 'address:current-address:flat-number',
            StreetName: 'address:current-address:street-name',
            AddressLine2: 'address:current-address:address-line-2',
            Town: 'address:current-address:town-city',
            County: 'address:current-address:county',
            YearsAtAddress: 'address:current-address:years-at-address',
            AddressLookup: 'address:current-address:list',
            FindAddressButton: 'find-current-address-button',
            EnterManuallyLink: 'lookup-current-address-link', // TODO: Update to better name after rollout, also move out to a "HELPERS" object or something similar - only have actual submitted form values in these objects
            SearchAddressLink: 'manual-current-address-link' // TODO: Update to better name after rollout
        },
        Previous: {
            LookupPostcode: 'previous-address-lookup-postcode',
            ActualPostcode: 'address:previous-address:postcode',
            HouseFlatNumber: 'previous-address-lookup-house-number',
            HouseNumber: 'address:previous-address:house-number',
            HouseName: 'address:previous-address:house-name',
            FlatNumber: 'address:previous-address:flat-number',
            StreetName: 'address:previous-address:street-name',
            AddressLine2: 'address:previous-address:address-line-2',
            Town: 'address:previous-address:town-city',
            County: 'address:previous-address:county',
            YearsAtAddress: 'address:previous-address:years-at-address',
            AddressLookup: 'address:previous-address:list',
            FindAddressButton: 'find-previous-address-button',
            EnterManuallyLink: 'lookup-previous-address-link',
            SearchAddressLink: 'manual-previous-address-link'
        }
    },
    Permissions: {
        Marketing: 'about-you:marketing-permission:marketing-permission',
        FutureSoftSearch: 'apply-screen:keeping-in-touch:future-soft-search-permission'
    }
};

export const autoCompleteMapping = {
    'title': 'honorific-prefix',
    'first-name': 'given-name',
    'last-name': 'family-name',
    'email-address': 'email',
    'date-of-birth': 'bday',
    'mobile-number': 'tel',
    'home-number': 'home tel',
    'occupation': 'organization-title',
    'house-number': 'street-address',
    'house-name': 'address-line1',
    'flat-number': 'address-level1',
    'street-name': 'address-line2',
    'address-line-2': 'address-line3',
    'town-city': 'address-level2',
    'county': 'address-level1',
    'postcode': 'postal-code'
};

export const requiredAboutYouFields = [
    FORM_SECTIONS.AboutYou.Title,
    FORM_SECTIONS.AboutYou.FirstName,
    FORM_SECTIONS.AboutYou.LastName,
    FORM_SECTIONS.AboutYou.DateOfBirth,
    FORM_SECTIONS.AboutYou.EmailAddress,
    FORM_SECTIONS.AboutYou.MobileNumber
];

export const requiredBTFields = [FORM_SECTIONS.AboutYou.BTAmount];

export const requiredEmploymentFields = [
    FORM_SECTIONS.Employment.EmploymentStatus,
    FORM_SECTIONS.Employment.YearlyIncome
];

export const requiredOutgoingFields = [
    FORM_SECTIONS.Outgoings.Dependants,
    FORM_SECTIONS.Outgoings.ResidentialStatus,
    FORM_SECTIONS.Outgoings.RentOrMortgageRate
];

export const requiredCurrentAddressFields = [
    // @ts-expect-error TS18048: 'FORM_SECTIONS.Address.Current' is possibly 'undefined'.
    FORM_SECTIONS.Address.Current.Town,
    // @ts-expect-error TS18048: 'FORM_SECTIONS.Address.Current' is possibly 'undefined'.
    FORM_SECTIONS.Address.Current.ActualPostcode,
    // @ts-expect-error TS18048: 'FORM_SECTIONS.Address.Current' is possibly 'undefined'.
    FORM_SECTIONS.Address.Current.YearsAtAddress
];

export const requiredPreviousAddressFields = [
    // @ts-expect-error TS18048: 'FORM_SECTIONS.Address.Previous' is possibly 'undefined'.
    FORM_SECTIONS.Address.Previous.Town,
    // @ts-expect-error TS18048: 'FORM_SECTIONS.Address.Previous' is possibly 'undefined'.
    FORM_SECTIONS.Address.Previous.ActualPostcode,
    // @ts-expect-error TS18048: 'FORM_SECTIONS.Address.Previous' is possibly 'undefined'.
    FORM_SECTIONS.Address.Previous.YearsAtAddress
];
